/* eslint-disable */

import React from 'react';
import PropTypes from 'prop-types';
import './ModalPopup.css';

class ModalPopup extends React.Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.state = {
      outsidedtect: false,
    };
  }

  render() {
    return (
      <>
        {this.props.options.enable === true && this.props.options.modaltype != '' ? (
          <>
            <div
              className={
                'meya-modal-generic ' +
                this.props.options.modaltype +
                (this.state.outsidedtect ? ' modal-chake' : '')
              }
              onClick={() => {
                this.setState({
                  outsidedtect: false,
                });
              }}
            >
              <div className='meya-modal-generic-body text-center'>
                <div
                  className={'meya-modal-generic-header font-th ' + this.props.options.modaltype}
                >
                  {this.props.options.modaltype === 'modal-success' && (
                    <div className='mb-2'>
                      <i className='mdi mdi-check-circle-outline' style={{ fontSize: '3.5rem' }}></i>
                    </div>
                  )}
                  {this.props.options.modaltype === 'modal-error' && (
                    <div className='mb-2'>
                      <i className='mdi mdi-alert-circle-outline' style={{ fontSize: '3.5rem' }}></i>
                    </div>
                  )}
                  {(this.props.options.modaltype === 'modal-warning' ||
                    this.props.options.modaltype === 'modal-confirm') && (
                      <div className='mb-2'>
                        <i className='mdi mdi-alert-outline' style={{ fontSize: '3.5rem' }}></i>
                      </div>
                    )}
                  {(this.props.options.modaltype === 'modal-info' ||
                    this.props.options.modaltype === 'modal-submitdoc' ||
                    this.props.options.modaltype === 'modal-signup') && (
                      <div className='mb-2'>
                        <i className='mdi mdi-information-outline' style={{ fontSize: '3.5rem' }}></i>
                      </div>
                    )}
                  <div className='font-weight-bold'>{this.props.options.headers}</div>
                </div>
                <div className='meya-modal-generic-content font-th mb-4 mt-2'>
                  {this.props.options.message}
                </div>
                {this.props.options.modaltype === 'modal-confirm' ? (
                  <div className={'d-flex justify-content-center gap-2'}>
                    <div
                      className='meya-modal-btn btn-warning font-th mr-2'
                      onClick={() => this.props.callback_confirm(this.props.options.confirmcode)}
                    >
                      {this.props.options.confirmLabel ? this.props.options.confirmLabel : 'ดำเนินการต่อ'}
                    </div>
                    <div
                      className='meya-modal-btn btn-light font-th'
                      onClick={() => this.props.callback_general('close')}
                    >
                      {this.props.options.cancelLabel ? this.props.options.cancelLabel : 'ยกเลิก'}
                    </div>
                  </div>
                ) : this.props.options.modaltype === 'modal-signup' ? (
                  <div className={'d-flex justify-content-center gap-2'}>
                    <div
                      className='meya-modal-btn btn-primary text-white font-th mr-2'
                      onClick={() => this.props.callback_confirm('ok')}
                    >
                      ไปยังหน้าลงทะเบียน
                    </div>
                    <div
                      className='meya-modal-btn btn-light font-th'
                      onClick={() => this.props.callback_general('close')}
                    >
                      ไม่ใช่ตอนนี้
                    </div>
                  </div>
                ) : this.props.options.modaltype === 'modal-submitdoc' ? (
                  <div className={'d-flex justify-content-center gap-2'}>
                    <div
                      className='meya-modal-btn btn-success text-white font-th mr-2'
                      onClick={() => this.props.callback_confirm('ok')}
                    >
                      แนบเอกสาร
                    </div>
                    <div
                      className='meya-modal-btn btn-light font-th'
                      onClick={() => this.props.callback_general('close')}
                    >
                      ไม่ใช่ตอนนี้
                    </div>
                  </div>
                ) : (
                  <div className={'d-flex justify-content-center'}>
                    <div
                      className='meya-modal-btn btn-light my-2 font-th'
                      onClick={() => this.props.callback_general('close')}
                    >
                      ปิด
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div
              className='meya-backdrop-generic'
              onClick={() => {
                this.setState({
                  outsidedtect: true,
                });
              }}
            ></div>
          </>
        ) : null}
      </>
    );
  }
}

ModalPopup.propTypes = {
  callback_general: PropTypes.func,
  callback_confirm: PropTypes.func,
};

export default ModalPopup;
